import request from '@/utils/request'
import API from '@/api/base'
import { importLocale } from '@/locale'
import { ApplicationError } from '@/utils/error'
import { getTrackingKey } from '@/utils/api'

class CheckoutV2API extends API {
  fetchData = ({ checkoutId, isFrame }) => {
    if (!checkoutId) {
      return Promise.reject(new ApplicationError('checkout_id is required!'))
    }

    const path = `${this.uri}/${checkoutId}?isFrame=${isFrame}`

    return request({
      method: 'GET',
      trackingKey: getTrackingKey(this.uri),
      path,
    })
  }

  submitData = ({ checkoutId, data = {}, options = {} }) => {
    if (!checkoutId) {
      return Promise.reject(new ApplicationError('checkout_id is required!'))
    }

    const dataToBeSent = { ...data, checkoutId }

    if (options?.omitCheckoutId ?? false) {
      delete dataToBeSent.checkoutId
    }

    const uri = options.uri ?? this.uri

    return request(
      {
        method: 'POST',
        trackingKey: getTrackingKey(this.uri, 'CHECKOUT-ID'),
        path: uri + `/${checkoutId}`,
        data: this.transformData(dataToBeSent, options),
      },
      { options }
    )
  }

  fetchMessages = (module, locale) => {
    return importLocale(module, locale)
  }

  getResponseCode = (checkoutId, sessionId) => {
    return request(
      {
        method: 'GET',
        trackingKey: getTrackingKey(
          this.uri,
          'CHECKOUT-ID_response-code_SESSION-ID'
        ),
        path: `${this.uri}/${checkoutId}/response-code/${sessionId}`,
      },
      {
        options: {
          attachCkoPublicKey: true,
        },
      }
    )
  }
}
export default new CheckoutV2API('/v2/checkout')
